import { MoreVertIcon } from "@/Components/Icons/Icons";
import ActionCellRenderer from "@/Views/ExportJob/Dashboard/ActionCellRenderer";

const columns = [
  {
    id: "0",
    field: "exportLockStatus",
    headerName: "OL",
    label: "OL",
    align: "left",
    alignItems: "left",
    justifyContent:"left",
    pinned: "left",
    minWidth: 70,
    maxWidth: 70,
    checked: true,
    stopRowClick: true,
  },
  {
    id: "1",
    field: "edocket",
    headerName: "E Docket",
    label: "E Docket",
    align: "left",
    alignItems: "left",
    pinned: "left",
    minWidth: 120,
    maxWidth: 120,
    checked: true,
    stopRowClick: true,
  },
  {
    id: "2",
    field: "jobNo",
    headerName: "Job Number",
    label: "Job Number",
    // // alignItems: "center",
    // justifyContent: "left",
    minWidth: 220,
    maxWidth: 280,
    pinned: "left",
    checked: true,
  },
  {
    id: "3",
    field: "jobDate",
    headerName: "Job Date",
    label: "Job Date",
    // align: "center",
    // alignItems: "center",
    // justifyContent: "flex-start",
    minWidth: 200,
    maxWidth: 250,
    checked: true,
    stopRowClick: true,
  },
  {
    id: "4",
    field: "importerName",
    headerName: "Importer",
    label: "Importer",
    // align: "center",
    // alignItems: "center",
    minWidth: 150,
    maxWidth: 200,
    checked: true,
    sort: true,
  },
  {
    id: "5",
    field: "supplierName",
    headerName: "SupplierName",
    label: "SupplierName",
    // align: "center",
    // alignItems: "center",
    minWidth: 150,
    maxWidth: 200,
    checked: true,
    sort: true,
  },

  {
    id: "6",
    field: "mawB_MBLNo",
    headerName: "MAWB_MBLNo",
    label: "MAWB_MBLNo",
    // align: "center",
    // alignItems: "center",
    minWidth: 150,
    maxWidth: 200,
    checked: true,
    sort: true,
    Notmove: true,
  },
  {
    id: "7",
    field: "hawB_HBLNo",
    headerName: "HAWB_HBLNo",
    label: "HAWB_HBLNo",
    // align: "center",
    // alignItems: "center",
    minWidth: 150,
    maxWidth: 200,
    sort: true,
    checked: true,
  },
  {
    id: "8",
    field: "mode",
    headerName: "Mode",
    label: "Mode",
    // align: "center",
    // alignItems: "center",
    minWidth: 150,
    maxWidth: 200,
    checked: true,
    sort: true,
  },
  {
    id: "9",
    field: "beDate",
    headerName: "BE_Date",
    label: "BE_Date",
    // align: "center",
    // alignItems: "center",
    minWidth: 200,
    maxWidth: 250,
    checked: true,
    sort: true,
    Notmove: true,
  },
  {
    id: "10",
    field: "igmNo",
    headerName: "IGMNo",
    label: "IGMNo",
    // align: "center",
    // alignItems: "center",
    minWidth: 200,
    maxWidth: 250,
    checked: true,
    Notmove: true,
    sort: true,
  },
  {
    id: "11",
    field: "BENo",
    headerName: "BENo",
    label: "BENo",
    // align: "center",
    // alignItems: "center",
    minWidth: 200,
    maxWidth: 250,
    checked: true,
    Notmove: true,
    sort: true,
  },
  {
    id: "12",
    field: "portOfShipment",
    headerName: "Port Of Shipment",
    label: "Port Of Shipment",
    // align: "center",
    // alignItems: "center",
    minWidth: 150,
    maxWidth: 200,
    checked: true,
    Notmove: true,
    sort: true,
  },
  {
    id: "13",
    field: "customHouse",
    headerName: "Custom House",
    label: "Custom House",
    // align: "center",
    // alignItems: "center",
    minWidth: 150,
    maxWidth: 200,
    checked: true,
    Notmove: true,
    sort: true,
  },
  {
    id: "14",
    field: "invoiceNumbers",
    headerName: "Invoice Numbers",
    label: "Invoice Numbers",
    // align: "center",
    // alignItems: "center",
    minWidth: 200,
    maxWidth: 250,
    checked: true,
    Notmove: true,
    sort: true,
  },
  {
    id: "15",
    field: "containerNumbers",
    headerName: "Container Numbers",
    label: "Container Numbers",
    // align: "center",
    // alignItems: "center",
    minWidth: 200,
    maxWidth: 250,
    checked: true,
    Notmove: true,
    sort: true,
  },
  {
    id: "actions",
    field: "actions",
    headerName: "Actions",
    label: "Actions",
    align: "center",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 80,
    maxWidth: 100,
    pinned: "right",
    Icon: MoreVertIcon,
    checked: true,
    cellRenderer: ActionCellRenderer,
    stopRowClick: true,
    
  },
];

export default columns;

